import React from 'react';
import DsButton from '../DsButton';
import RawDsModal from '../DsModal';
import { SkeletonAvatar, SkeletonLine } from '../Skeleton';
import { PersonAvatarLabel as RawPersonAvatarLabel } from '../avatar/PersonAvatar';
import type { listEventAssignmentAdminCandidates } from '../../../api/taskEvents';
import '../../../css/common/events/EventAssignmentSettingsModal.css';

const DsModal = RawDsModal as React.ComponentType<any>;
const PersonAvatarLabel = RawPersonAvatarLabel as React.ComponentType<any>;
export type AssignmentAdmin = NonNullable<Awaited<ReturnType<typeof listEventAssignmentAdminCandidates>>['adminUsers']>[number];
type Props = {
  open: boolean; adminId: number | string | null; draftIds: number[];
  candidates: AssignmentAdmin[]; loading: boolean; saving: boolean;
  search: string; onSearch: (value: string) => void; onToggle: (id: number) => void;
  onClose: () => void; onSave: () => void; error?: string; onRetry?: () => void;
  saveDisabled?: boolean;
};
export default function EventAssignmentSettingsModal({
  open, adminId, draftIds, candidates, loading, saving, search, onSearch, onToggle,
  onClose, onSave, error = '', onRetry, saveDisabled = false,
}: Props) {
  return <DsModal open={open} onClose={onClose} title="担当者設定" size="md"
    dismissible={!saving} className="event-assignment-settings-modal"
    footer={<DsButton block onClick={onSave} disabled={saving || loading || saveDisabled} loading={saving}>
      {saving ? '保存中...' : '保存'}
    </DsButton>}>
    <div className="event-assignment-settings-modal__quick">
      <DsButton variant="secondary" onClick={() => onToggle(Number(adminId))} disabled={!adminId || loading || saving}>
        {draftIds.some(id => Number(id) === Number(adminId)) ? '自分を担当から外す' : '自分を担当に追加'}
      </DsButton>
      <span>{draftIds.length}人を選択中</span>
    </div>
    {error ? <div role="alert" className="event-assignment-settings-modal__error">
      {error}
      {onRetry ? <DsButton variant="secondary" onClick={onRetry} disabled={loading || saving}>再読み込み</DsButton> : null}
    </div> : null}
    <input className="event-assignment-settings-modal__search" type="search" value={search}
      onChange={event => onSearch(event.target.value)} placeholder="管理者名で検索" aria-label="管理者名で検索" />
    <div className="event-assignment-settings-modal__list">
      {loading ? <div role="status" aria-label="担当者を読み込み中">
        {[0, 1, 2, 3, 4].map(index => <div key={index} className="event-assignment-settings-modal__row" aria-hidden="true">
          <SkeletonAvatar size={24} /><SkeletonLine width="68%" height={12} />
        </div>)}
      </div> : candidates.length ? candidates.map(admin => {
        const id = Number(admin.id ?? admin.admin_user_id);
        const label = admin.display_name || admin.full_name || admin.nickname || admin.username || `ID ${id}`;
        return <label key={id} className="event-assignment-settings-modal__row">
          <input type="checkbox" aria-label={label} checked={draftIds.includes(id)} onChange={() => onToggle(id)} disabled={saving} />
          <PersonAvatarLabel person={admin} role="admin" label={label}
            subLabel={[admin.department, admin.position].filter(Boolean).join(' / ')} size={32}
            className="event-assignment-settings-modal__person" />
        </label>;
      }) : <p className="event-assignment-settings-modal__empty">担当者候補が見つかりません。</p>}
    </div>
  </DsModal>;
}
